import React from 'react';
import { Box, Button, Grid, Typography } from '@mui/material';
import DashboardCard from 'components/DashboardCard';
import DataObject from '@mui/icons-material/DataObject';
import customCodesSx from '../CustomCodes.styles';
import { useTheme } from '@mui/material/styles';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../CustomCodes.redux';
import SelectCategory from './SelectCategory';
import SelectType from './SelectType';
import Configurator from './Configurator';
import { formatCodeCategory, formatCodeType } from '../CustomCodes.utils';
import { codeColorMap } from 'lib/colors';

const CustomCodeForm = () => {
    const theme = useTheme(),
        sx = customCodesSx(theme),
        dispatch = useDispatch(),
        step = useSelector((state) => state.customCodes.step),
        category = useSelector((state) => state.customCodes.category),
        type = useSelector((state) => state.customCodes.type);

    const handleReset = () => dispatch(actions.resetAll());
    const isInitialSetup = step === 'initial-setup';

    console.log({ step, isInitialSetup });

    return (
        <DashboardCard
            color={'orange'}
            icon={<DataObject />}
            topContent={'Custom Codes'}
            topLabel={
                <>
                    <div>Continue editing your Custom Code or</div>
                    <div>
                        <Button variant="contained" size="small" color="primary" sx={sx.buttons} onClick={handleReset}>
                            Return to list
                        </Button>
                    </div>
                </>
            }
            size={'xl'}
        >
            {isInitialSetup && (
                <Typography variant="body1" sx={{ mb: '24px' }}>
                    Choose a category and type for your code. Once you proceed to the next step, you will be unable to
                    change these selections, so choose carefully!
                </Typography>
            )}
            <Grid container spacing={3} sx={{ maxWidth: '600px', marginBottom: '24px' }}>
                <Grid size={{ xs: 12, md: 6 }} sx={{ height: '72px' }}>
                    <Box
                        sx={{
                            height: '100%',
                            background: '#ffffff',
                            borderRadius: '4px',
                            boxShadow: isInitialSetup
                                ? undefined
                                : '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)',
                            width: '250px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        {isInitialSetup && <SelectType />}
                        {!isInitialSetup && (
                            <Box sx={{ color: '#000000', textAlign: 'center' }}>
                                <Typography variant="h6">Code Type</Typography>
                                <Typography>{formatCodeType(type)}</Typography>
                            </Box>
                        )}
                    </Box>
                </Grid>

                <Grid size={{ xs: 12, md: 6 }} sx={{ height: '72px' }}>
                    <Box
                        sx={{
                            height: '100%',
                            background: isInitialSetup ? '#ffffff' : (codeColorMap[category] ?? codeColorMap.unknown),
                            borderRadius: '4px',
                            boxShadow: isInitialSetup
                                ? undefined
                                : '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)',
                            width: '250px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        {isInitialSetup && <SelectCategory />}
                        {!isInitialSetup && (
                            <Box sx={{ color: '#000000', textAlign: 'center' }}>
                                <Typography variant="h6">Category</Typography>
                                <Typography>{formatCodeCategory(category)}</Typography>
                            </Box>
                        )}
                    </Box>
                </Grid>
            </Grid>

            {isInitialSetup && (
                <Button
                    disabled={!category || !type}
                    variant="contained"
                    color="primary"
                    onClick={() => dispatch(actions.setState({ step: 'edit-code' }))}
                >
                    Continue
                </Button>
            )}

            {!isInitialSetup && <Typography sx={{ marginBottom: '24px' }}>Configuration</Typography>}
            {!isInitialSetup && <Configurator />}
        </DashboardCard>
    );
};

export default CustomCodeForm;
